export default "__VITE_ASSET__CPgCpzav__"